import NextLink from "next/link";

import { cn } from "@flare/ui";

import type { LinkProps } from "./Link.types";

export const Link = ({
  pathname = "",
  href,
  children,
  className,
  onClick,
  attributes: builderAttributes,
  openInNewTab,
}: LinkProps) => {
  const isExternalLink = !!href;
  const target = openInNewTab ? "_blank" : "_self";

  const {
    key,
    className: builderClassName,
    ...restBuilderAttributes
  } = builderAttributes ?? {
    key: undefined,
    className: "",
  };

  const ATag = (
    <a
      key={key}
      className={cn(className, builderClassName)}
      href={href}
      onClick={onClick}
      target={target}
      {...restBuilderAttributes}
    >
      {children}
    </a>
  );
  // Use Atag for external urls (when we received href prop) and NextLink for in-app navigation(using pathname).
  return isExternalLink ? (
    ATag
  ) : (
    <NextLink
      key={key}
      legacyBehavior
      href={pathname}
      passHref
      target={target}
      className={cn("no-underline", builderClassName)}
      {...restBuilderAttributes}
    >
      {ATag}
    </NextLink>
  );
};
